// src/themes/sunset.ts
import { Theme } from "./types";

export const sunsetTheme: Theme = {
  "background-light": "24 24 27", // #18181B - Deep gray with purple undertone
  "background-dark": "20 20 23", // #141417 - Darker background
  "card-light": "39 39 42", // #27272A - Sunset card
  "card-dark": "35 35 38", // #232326 - Darker card
  "input-light": "63 63 70", // #3F3F46 - Sunset input
  "input-dark": "55 55 62", // #37373E - Darker input
  "border-light": "82 82 91", // #52525B - Sunset border
  "border-dark": "75 75 84", // #4B4B54 - Darker border
  primary: "249 115 22", // #F97316 - Vibrant orange
  "primary-hover": "234 88 12", // #EA580C - Deep orange
  text: "250 250 250", // #FAFAFA - Bright white
  "text-dark": "245 245 245", // #F5F5F5 - Soft white
  "text-secondary": "212 212 216", // #D4D4D8 - Light gray
  "text-secondary-dark": "161 161 170", // #A1A1AA - Muted gray
};
